<template>
  <v-container>
    <v-card
      color="#efefef"
      class="ma-0 mb-5"
    >
      <!-- <v-row
        justify="center"
        class="pa-5 "
      >
        {{ steporder }}
      </v-row> -->
      <v-row>
        <div class="text-h3 text-weigth-light ma-6">
          Componenti
        </div>
      </v-row>
      <v-form
        ref="form"
        v-model="validForm"
      >
        <v-row class="pa-5 ">
          <!-- PONTE non c'è-->

          <!-- ASTE -->
          <v-col
            cols="12"
            md="6"
          >
            <v-autocomplete
              v-model="steporder.vlaste"
              outlined
              :items="dataitems.filter(item => (item.compo === 'ASTE'))"
              :rules="[rules.required]"
              color="blue-grey lighten-2"
              label="Tipo Aste"
              item-text="tipcompo"
              return-object
              clearable
              class="ma-0 pa-0 text-body-1"
              height="55px"
              @change=" $set(steporder, 'vlterm', null) "
            >
              <template v-slot:selection="data">
                <v-avatar
                  rounded
                  left
                  width="55"
                >
                  <v-img
                    :src="`./img/ASTE/${$linea().label}_${data.item.tipcompo}.png`"
                    contain
                  />
                </v-avatar>

                <span class="pl-4">{{ data.item.descompo }}</span>
              </template>
              <template
                v-slot:item="data"
              >
                <v-list-item-avatar
                  rounded
                  width="130"
                  height="auto"
                >
                  <v-img
                    :src="`./img/ASTE/${$linea().label}_${data.item.tipcompo}.png`"
                    contain
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <span class="pl-4"> {{ data.item.descompo }}</span>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
          <!-- TERMINALI -->
          <v-col
            cols="12"
            md="6"
          >
            <v-autocomplete
              v-model="steporder.vlterm"
              :disabled="!steporder.vlaste"
              outlined
              :items="dataitems.filter(item => (item.compo === 'TERM'))"
              :rules="[rules.required]"
              color="blue-grey lighten-2"
              label="Tipo Terminale"
              item-text="tipcompo"
              return-object
              clearable
              class="ma-0 pa-0 text-body-1"
              height="55px"
              @change="$set(steporder, 'fascia', 'NO')"
            >
              <template v-slot:selection="data">
                <v-avatar
                  rounded
                  left
                  width="55"
                >
                  <v-img
                    :src="`./img/TERM/${$linea().label}_${data.item.tipcompo}.png`"
                    contain
                  />
                </v-avatar>

                <span class="pl-4">{{ data.item.descompo }}</span>
              </template>
              <template
                v-slot:item="data"
              >
                <v-list-item-avatar
                  rounded
                  width="80"
                  height="auto"
                >
                  <v-img
                    :src="`./img/TERM/${$linea().label}_${data.item.tipcompo}.png`"
                    contain
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <span class="pl-4"> {{ data.item.descompo }} </span>
                </v-list-item-content>
              </template>
            </v-autocomplete>
            <template v-if="[7,8].includes(+steporder?.vlterm?.tipcompo)">
              <v-checkbox
                v-model="steporder.fascia"
                dense
                hide-details
                true-value="SI"
                false-value="NO"
                :label="`Fascia elastica inclusa? ${steporder.fascia}`"
                color="primary"
              />
            </template>
          </v-col>
          <!-- Nasello -->
          <v-col
            cols="12"
            md="6"
          >
            <v-autocomplete
              v-model="steporder.nasell"
              outlined
              :items="dataitems.filter(item => (item.compo === 'NAS'))"
              :rules="[rules.required]"
              color="blue-grey lighten-2"
              label="Tipo Nasello"
              item-text="tipcompo"
              return-object
              clearable
              class="ma-0 pa-0 text-body-1"
              height="55px"
            >
              <template v-slot:selection="data">
                <v-avatar
                  rounded
                  left
                >
                  <v-img
                    :src="`./img/NAS/${data.item.tipcompo}.png`"
                    contain
                  />
                </v-avatar>

                <span class="pl-4">{{ data.item.descompo }}</span>
              </template>
              <template
                v-slot:item="data"
              >
                <v-list-item-avatar
                  rounded
                  width="80"
                  height="auto"
                  @click="$set(steporder,'alette',null);$forceUpdate()"
                >
                  <v-img
                    :src="`./img/NAS/${data.item.tipcompo}.png`"
                    height="auto"
                    max-width="40px"
                    contain
                  />
                </v-list-item-avatar>
                <v-list-item-content @click="$set(steporder,'alette',null);$forceUpdate()">
                  <span class="pl-4"> {{ data.item.descompo }}</span>
                </v-list-item-content>
              </template>
            </v-autocomplete>

            <v-radio-group
              v-if="steporder?.nasell?.tipcompo &&steporder.nasell.tipcompo === '8'"
              v-model="steporder.alette"
              :disabled="steporder.nasell.tipcompo!=8"
              column
              :rules="[rules.required]"
              required
              class="ma-0 pa-0 "
            >
              <v-radio
                label="aletta piccola"
                value="1"
              >
                <template
                  v-slot:label
                >
                  <v-img
                    :src="`./img/NAS/aletta_piccola.png`"
                    height="auto"
                    max-width="30px"
                    class="mr-2"
                  /> alette piccole
                </template>
              </v-radio>
              <v-radio
                label="aletta grande"
                value="2"
              >
                <template
                  v-slot:label
                >
                  <v-img
                    :src="`./img/NAS/aletta_grande.png`"
                    height="auto"
                    max-width="30px"
                    class="mr-2"
                  /> alette grandi
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <v-btn
      color="primary"
      :disabled="!validForm "
      @click="nextStep"
    >
      Avanti
    </v-btn>
    <v-btn
      text
      @click="prevStep"
    >
      Indietro
    </v-btn>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import engine from '@/plugins/engine'

  export default {
    name: 'Step3',
    props: {
      step: {
        type: Number,
        default: null,
      },
    },
    data () {
      return {
        test: [{ codlin: 'JOY', compo: 'PONT', tipcompo: '1', last_update: '2024-09-10 16:05:07' }, { codlin: 'JOY', compo: 'PONT', tipcompo: '2', last_update: '2024-09-10 16:05:07' }],
        steporder: {},
        validForm: true,
        compo: [],
        vincoli: [],
        menu_ponte: false,
        menu_asta: false,
        menu_term: false,
        menu_nas: false,
        isEditing: true,
      }
    },
    computed: {
      ...mapState(['auth', 'order', 'clidata']),
      rules () {
        return {
          required: value => !!value || 'Required.',
          min: v => (v && v.length >= 4) || 'Min 4 characters',
        }
      },
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

      dataitems () {
        // return this.compo.filter(item => (item.compo === 'PONT'))
        if (this.steporder.vlaste) {
          var filter = this.vincoli.filter(item => item.master === `ASTE:${this.steporder.vlaste.tipcompo}`)
          var arrayElements = []
          var vincolo
          filter.forEach(element => {
            vincolo = element.slave.split(':')
            arrayElements.push(vincolo[1])
          })
          var compofilterd = this.compo.filter(item => (item.compo === vincolo?.[0] && !arrayElements.includes(item.tipcompo)))
          console.log('compofilterd', compofilterd)
          return this.compo.filter(item => (item.compo !== vincolo?.[0] || !compofilterd.includes(item)))
        }
        return this.compo
      },
    },
    watch: {
      step (newVal, oldVal) {
        this.initData(newVal)
      },
    },
    created () {
      // this.$store.watch(
      //   (state) => state.order,
      //   (newValue, oldValue) => {
      //     console.log('Order changed from', oldValue, 'to', newValue)
      //     if (newValue) {
      //       this.steporder = Object.assign({}, newValue)
      //     }
      //   },
      //   {
      //     deep: true, // Optional: Use this if you need to watch nested properties
      //   },
      // )
    },
    mounted () {
      this.initData(this.step)
      // window.addEventListener('beforeunload', this.preventNav)
      // this.steporder = Object.assign({}, this.order)
      // this.loadCompo()
    },
    beforeDestroy () {
      // window.removeEventListener('beforeunload', this.preventNav)
      // console.log(' step3 beforedestroyed')
    },
    methods: {
      initData (stp) {
        if (this.$options.name === `Step${stp}`) {
          console.log('load', this.$options.name)
          this.steporder = Object.assign({}, this.order)
          if (this.compo.length === 0) {
            this.loadCompo()
          }
          if (typeof this.steporder?.fascia === 'undefined') {
            this.$set(this.steporder, 'fascia', 'NO')
          }
          this.tipcol = this.steporder.tipcol
        }
      },
      nextStep () {
        if (!this.validForm) { return }
        if (this.step > this.steporder.step) { this.steporder.step = this.step }
        console.log('steporder', this.steporder)
        this.$store.commit('setOrder', this.steporder)
        this.$emit('nextStep', this.step + 1)
      },
      prevStep () {
        if (this.$store.state.order.monsmo === 'S') {
          this.$emit('prevStep', this.step - 1)
          return
        }
        this.$emit('prevStep', this.step)
      },
      loadCompo () {
        this.loading = true
        engine.get_compo(this.$linea().label)
          .then(result => {
            if (result.error) {
              this.$store.commit('setSnack', { message: result.error_reason, color: '#c54747d4' })

              return
            }
            this.compo = result.data
            this.vincoli = result.vincoli
          })
          .catch((errore) => {
            console.log(errore)
          }).finally(() => { this.loading = false })
      },
      preventNav (event) {
        if (this.isEditing) {
          console.log('isEditing', this.isEditing)
          event.preventDefault()
          event.returnValue = '' // Required for Chrome
        }
      },
    },
  }
</script>
